import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-telesuivi-graphique-hint-observance-et-iahr',
  standalone: true,
  imports: [DecimalPipe, DatePipe],
  templateUrl: './telesuivi-graphique-hint-observance-et-iahr.component.html',
  styleUrl: './telesuivi-graphique-hint-observance-et-iahr.component.scss',
})
export class TelesuiviGraphiqueHintObservanceEtIahrComponent {
  @Input() index: number = 0;
  @Input() obsList: Array<number> = [];
  @Input() iahrList: Array<number> = [];
  @Input() dateList: Array<Date> = [];
}
